// extracted by mini-css-extract-plugin
export var layoutContainer = "_68-0";
export var layoutContainerNoRounding = "_68-6";
export var layoutContainerOpen = "_68-5";
export var layoutContainerResizing = "_68-1";
export var mainContent = "_68-2";
export var resizeDivider = "_68-3";
export var slidePanel = "_68-4";